<template>
  <div class="">

            <div class="contingut bg-darkBlue row g-0">
                <div class="col-12 mt-4 mb-3 mb-lg-2">
                    <h2 class="text-turquesa">{{ $t('acciones.title') }}</h2>
                </div>
            </div>

            <div class="contingut bg-white row g-0">
                <div class="row">
                    <div class="col pt-0 pt-lg-5 mt-2 mt-lg-5">
                      <img :src="`${publicPath}img/02waterAcciones00.jpg`" class="img-responsive mb-5" data-aos="fade" data-aos-easing="linear" data-aos-duration="1000">
                      <h3 class="text-blau2 mb-4" data-aos="fade" data-aos-duration="1000">{{ $t('acciones.compartiendo') }}</h3>
                      <h4 class=" text-turquesa p-1 p-lg-5 pt-lg-0 pb-5 mx-0 mx-md-5">{{ $t('acciones.junto') }}</h4>
                    </div>
                </div>
            </div>

      <div class="contingut bg-white row g-0">
          <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel" data-bs-wrap="false">
              <div class="carousel-inner">
                  <div class="carousel-item active">
                      <div class="row justify-content-center pb-0 pb-lg-5 mb-0 mb-lg-5">
                          <div class="col-12 col-md-6 col-lg-5 p-3 text-center text-lg-start">
                              <img :src="`${publicPath}img/02waterLetsMake.jpg`" class="img-responsive mb-4" data-aos="fade" data-aos-easing="linear" data-aos-delay="200" data-aos-duration="1000">
                              <h3 class="text-turquesa mb-3">"{{ $t('acciones.lets') }}"</h3>
                              <hr>
                              <p>{{ $t('acciones.lets_txt') }}</p>
                          </div>
                          <div class="col-12 col-md-6 col-lg-5 p-3  text-center text-lg-start">
                              <img :src="`${publicPath}img/02waterAquanautas.jpg`" class="img-responsive mb-4" data-aos="fade" data-aos-easing="linear"  data-aos-duration="1000">
                              <h3 class="text-turquesa mb-3">"{{ $t('acciones.aquanautas') }}"</h3>
                              <hr>
                              <p>{{ $t('acciones.aquanautas_txt') }}</p>
                          </div>
                      </div>
                  </div>
                  <div class="carousel-item">
                      <div class="row justify-content-center pb-0 pb-lg-5 mb-0 mb-lg-5">
                          <div class="col-12 col-md-6 col-lg-5 p-3  text-center text-lg-start">
                              <img :src="`${publicPath}img/02waterSmart.jpg`" class="img-responsive mb-4" data-aos="fade" data-aos-easing="linear" data-aos-delay="100" data-aos-duration="1000">
                              <h3 class="text-turquesa mb-3">"{{ $t('acciones.smart') }}"</h3>
                              <hr>
                              <p>{{ $t('acciones.smart_txt') }}</p>
                          </div>
                          <div class="col-12 col-md-6 col-lg-5 p-3 text-start">
                          </div>
                      </div>
                      </div>
              </div>
              <button class="carousel-control-prev d-none d-md-block" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                  <img :src="`${publicPath}img/carouselBack.png`" class="img-responsive">
                  <span class="visually-hidden">Previous</span>
              </button>
              <button class="carousel-control-next d-none d-md-block" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                  <img :src="`${publicPath}img/carouselNext.png`" class="img-responsive">
                  <span class="visually-hidden">Next</span>
              </button>
          </div>
          <hr>
          <div class="row g-0 p-0">
              <div class="col-12 p-3 p-lg-0 m-0 pb-3 pb-lg-5 text-start">
                  <localized-link class="footerLink" to="/fundacion-we-are-water/proyectos-de-cooperacion"><img :src="`${publicPath}img/breadcrumbBack.gif`" class="img-responsive" width="6"> {{ $t("nav.proyectos-de-cooperacion") }}</localized-link>
              </div>
          </div>
      </div>

  </div>
</template>


<script>
  export default {
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    }
  }
</script>
